// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.05 8.57L8.57 3.05C9.78 1.84 11.74 1.84 12.95 3.05C14.16 4.26 14.16 6.22 12.95 7.43L7.43 12.95C6.22 14.16 4.26 14.16 3.05 12.95C1.84 11.74 1.84 9.78 3.05 8.57Z',
  'M5.81 5.81L10.19 10.19',
];
